type VerificationStatus =
  | 'canceled'
  | 'processing_test'
  | 'processing'
  | 'requires_input'
  | 'verified';

export interface NewIdentitySession {
  clientSecret: string;
  id: string;
  status: VerificationStatus;
}

export interface StripeIdentityUser {
  status: VerificationStatus;
  firstName: string;
  lastName: string;
  bornAt: Date;
  error: string | null;
}

// Convert the value received from Stripe to a string that can be managed by the registration form
// Returns a 'YYYY-MM-DD' string
export function getDob(input: StripeIdentityUser): string {
  const utcDate = input.bornAt.getUTCDate();
  const utcMonth = input.bornAt.getUTCMonth() + 1;

  const month = utcMonth < 10 ? `0${utcMonth}` : `${utcMonth}`;
  const day = utcDate < 10 ? `0${utcDate}` : `${utcDate}`;

  return `${input.bornAt.getUTCFullYear()}-${month}-${day}`;
}
